import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            平台优势
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            三大核心能力，让你吃瓜快人一步、深人一层、乐在其中
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="group p-6 md:p-8 rounded-2xl bg-background-50 hover:bg-background-50 transition-colors border border-background-200/70 text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto rounded-2xl bg-primary-100/70 flex items-center justify-center mb-5 group-hover:bg-primary-200/70 transition-colors">
                <i className={`${item.icon} text-primary-500 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}